export const FETCH_PARTNERS_SUCCESS = 'fetch_partners_success'
export const ADD_PARTNER_SUCCESS = 'add_partner_success'
export const UPDATE_PARTNER_SUCCESS = 'update_partner_success'
export const FETCH_PARTNER_DETAILS_SUCCESS = 'fetch_partner_details_success'
export const FETCH_PARTNER_METRICS_SUCCESS = 'fetch_partner_metrics_success'
